<template>
  <v-select
    outlined
    hide-details
    clearable
    item-text="description"
    item-value="key"
    :items="items"
    :label="label"
    v-model="localValue"
    v-bind="$attrs"
    @blur="onBlur"
    @change="onChange"
  />
</template>

<script>
export default {
  props: {
    label: String,
    items: Array,
    value: [String, Array],
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
  },
};
</script>
